module.exports = __webpack_public_path__ + "893a0d127e164a2260ca9811e3d1b48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ucenter/order_success.png
// module id = 509
// module chunks = 0 1